<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'modals.add_ingredient' | translate }} 
    v-card-content
      v-select.mb-3(
        label="base.type"
        api-search
        :options="ingredientTypes"
        v-model="ingredient_type"
        @input="onTypeChange"
        @search="onIngredientTypeSearch")
      v-input-r.mb-2(
        v-if="ingredient_type"
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        v-model="name")
      v-input-r(
        :label="$t('base.dry_metter')"
        :hint="errorMessage('dry_matter')"
        :invalid="!!errorMessage('dry_matter')"
        type="number"
        min="0"
        max="100"
        v-model="dry_matter")
      v-switch(
        :label="$t('history.ignore_in_reports')"
        v-model="ignored_in_report")
      v-switch(
        :label="$t('history.autoload')"
        v-model="auto_load")
    v-card-actions
      v-btn(
        :loading="loading"
        :disabled="!isValid"
        @click="onCreateIngredient")
        | {{ 'base.add' | translate }}
</template>

<script>
import api from '@/api'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

export default {
  name: 'CreateModal',

  mixins: [formErrorsMixin],

  data: () => ({
    name: null,
    dry_matter: 0,
    ignored_in_report: false,
    ingredient_type: null,
    auto_load: false,
    loading: false,
    ingredientTypes: []
  }),

  mounted () {
    this.onIngredientTypeSearch()
  },

  computed: {
    isValid () {
      return !!(this.name &&
        this.ingredient_type)
    }
  },

  methods: {
    onTypeChange (id) {
      const ingredientType = this.ingredientTypes
        .find(item => item.id === id)
      if (ingredientType) {
        this.name = ingredientType.name
      }
    },

    async onIngredientTypeSearch (value = null) {
      const params = {
        name: value,
        limit: 200
      }
      const { data } = await api.ingredienttypes.litelist(params)
      this.ingredientTypes = data
    },

    async onCreateIngredient () {
      this.loading = true
      const payload = {
        name: this.name,
        farm: null,
        dry_matter: +this.dry_matter,
        ignored_in_report: this.ignored_in_report,
        stock: { id: +this.$route.params.stock_id },
        ingredient_type: { id: this.ingredient_type },
        auto_load: this.auto_load
      }
      const { errors } = await api.ingredients.create(payload)
      this.errors = errors
      this.loading = false
      if (errors) {
        if (errors.non_field_errors && errors.non_field_errors[0] === '5') {
          this.$toasted.error(this.$t('errors.incorrect_ingredient_type'))
        }
      } else {
        this.$emit('update')
        this.$emit('close')
      }
    }
  }
}
</script>
<style scoped>
.v-card__content {
  margin-top: 2rem;
  border-top: .1rem solid #d7d7d7;
  padding: 2rem;
  padding-top: 4rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.v-card__actions {
  display: flex;
  align-items: center;
  gap: 2rem;
}
.v-card__actions button {
  width: 100%;
}
</style>